export default __webpack_public_path__ + "static/media/DMSLogo.b3aed291.svg";